import { flagPathPrefixes, pathMatchesPrefix } from './flag-paths'

export const MAINTENANCE_FLAG_PREFIX = 'under-maintenance:'

/** Gated route prefixes, from 'under-maintenance:<path>' flag keys ('/' gates the whole app). */
export function maintenancePathPrefixes(flags: string[]): string[] {
  return flagPathPrefixes(flags, MAINTENANCE_FLAG_PREFIX)
}

export function isUnderMaintenance(path: string, prefixes: string[]): boolean {
  return pathMatchesPrefix(path, prefixes)
}
